module.exports = require("./../../_gen/starling/display/Image");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/display/Image.js
// module id = 167
// module chunks = 0